import { Clock, MapPin, Phone, Scissors, Instagram } from "lucide-react";

const SHOP_IMG =
  "https://images.pexels.com/photos/9146943/pexels-photo-9146943.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-amber-500/15">
      <div className="mx-auto max-w-md px-4 py-14 md:max-w-2xl lg:max-w-4xl">
        <div className="overflow-hidden rounded-2xl border border-amber-500/15">
          <img
            data-testid="footer-shop-image"
            src={SHOP_IMG}
            alt="Interior da barbearia"
            className="h-48 w-full object-cover"
            loading="lazy"
          />
        </div>

        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          <div className="rounded-xl border border-amber-500/15 bg-[#161618] p-4">
            <Clock className="h-5 w-5 text-amber-400" />
            <p className="mt-2 text-sm font-semibold text-zinc-100">Horário</p>
            <p className="mt-1 text-xs leading-relaxed text-zinc-400">
              Terça a sábado
              <br />
              9h às 20h
            </p>
          </div>
          <div className="rounded-xl border border-amber-500/15 bg-[#161618] p-4">
            <MapPin className="h-5 w-5 text-amber-400" />
            <p className="mt-2 text-sm font-semibold text-zinc-100">Endereço</p>
            <p className="mt-1 text-xs leading-relaxed text-zinc-400">
              Rua Ulisses Guimarães, 177
              <br />
              Novo Jockey · Campos dos Goytacazes, RJ
            </p>
          </div>
          <a
            data-testid="footer-whatsapp-link"
            href="https://wa.me/5522998120484"
            target="_blank"
            rel="noreferrer"
            className="block rounded-xl border border-amber-500/15 bg-[#161618] p-4 transition-colors hover:border-amber-500/50"
          >
            <Phone className="h-5 w-5 text-amber-400" />
            <p className="mt-2 text-sm font-semibold text-zinc-100">Contato</p>
            <p className="mt-1 text-xs leading-relaxed text-zinc-400">
              WhatsApp
              <br />
              (22) 99812-0484
            </p>
          </a>
          <a
            data-testid="footer-instagram-link"
            href="https://instagram.com/resenhaducorteoficial"
            target="_blank"
            rel="noreferrer"
            className="block rounded-xl border border-amber-500/15 bg-[#161618] p-4 transition-colors hover:border-amber-500/50"
          >
            <Instagram className="h-5 w-5 text-amber-400" />
            <p className="mt-2 text-sm font-semibold text-zinc-100">Instagram</p>
            <p className="mt-1 text-xs leading-relaxed text-zinc-400">@resenhaducorteoficial</p>
          </a>
        </div>

        <div className="mt-10 flex flex-col items-center gap-2 border-t border-zinc-900 pt-6 text-center">
          <span className="flex items-center gap-2">
            <img
              src="/logo.png"
              alt="Logo Resenha dú Corte"
              className="h-9 w-9 rounded-full border border-amber-500/40 object-cover"
            />
            <span className="font-display text-lg text-amber-100">RESENHA DÚ CORTE</span>
          </span>
          <p className="text-xs text-zinc-600">
            © {new Date().getFullYear()} Resenha dú Corte. Tradição & estilo.
          </p>
        </div>
      </div>
    </footer>
  );
}
